"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Delete = function Delete() {
  return _react2.default.createElement(
    "g",
    { id: "delete" },
    _react2.default.createElement("path", {
      d: "M78.25,440.583333 C77.1666667,471.5 100.75,497.666667 131.583333,499.916667 L367,499.916667 C398.25,497.833333 422.5,471.833333 422.416667,440.583333 L422.416667,129.583333 L78.25,129.583333 L78.25,440.583333 L78.25,440.583333 Z M421.583333,37 L330.75,37 C331.916667,18.9166667 319.083333,2.83333333 301.166667,0 L197.416667,0 C179.5,2.91666667 166.666667,18.9166667 167.833333,37 L77.4166667,37 C59.3333333,35.5833333 43.5833333,49.0833333 42.0833333,67.0833333 C42,68.1666667 42,69.25 42,70.3333333 L42,92.6666667 L458.666667,92.6666667 L458.666667,70.3333333 C458.25,51.4166667 442.583333,36.5 423.75,36.9166667 C423,36.9166667 422.25,37 421.583333,37 L421.583333,37 Z",
      id: "Shape"
    })
  );
};

exports.default = Delete;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Delete.js
// module id = 2939
// module chunks = 4